import React from 'react';

import Timeline from './Timeline';

const EdExpWrapper = ({ items, title }) => {
    return (
        <div className='text-white'>
            <h1 className='text-center font-bold text-5xl'>{title}</h1>
            <div className='mx-auto my-2 py-2 max-w-6xl'>
                <h1 className='text-center font-bold text-3xl my-2'>
                    {items[0].title}
                </h1>
                <Timeline items={items[0]} />
            </div>

        </div>
    );
};

export default EdExpWrapper;
